export function validateSelectedUsers(param) {
  if (param && param.length > 0) return true;
  return false;
}
